import React, { Component } from "react";
import _ from "lodash";
import { Field, reduxForm } from "redux-form";
import { Row, Col, Form } from "reactstrap";
import { connect } from "react-redux";
// import actionFilter from "../../store/advancedfilter/action";
import actionFilter from "../../../store/advancedfilter/action";

class Employer extends Component {
  onChange(item) {
    var employerIndex = _.findIndex(
      this.props.filterState.filterData.employer,
      (o) => {
        return o.id === item.id;
      }
    );
    item.checked = !this.props.filterState.filterData.employer[employerIndex]
      .checked;
    this.props.filterState.filterData.employer[employerIndex] = item;
    this.props.setFilterData({
      ...this.props.filterState.filterData,
    });
  }
  chechboxes(item) {
    return (
      <li class="chechbox-list_item" key={"erliitem-" + item.id}>
        <span
          className="card-text custom-checkbox ml-3 mr-4"
          key={"eritem-" + item.id}
        >
          <input
            type="checkbox"
            htmlFor={"eritem-" + item.id}
            value={item.id}
            checked={item.checked}
            className="custom-control-input position-absolute"
            id={"eritem-" + item.id}
            name={"eritem-" + item.id}
            onChange={() => this.onChange(item)}
          />

          <label
            className="custom-control-label"
            htmlFor={"eritem-" + item.id}
          ></label>
          <span
            style={{
              verticalAlign: "sub",
              color: this.props.isMobile ? "white" : null,
            }}
          >
            {item.options}
            <small className="align-text-top totalCount">{`(${item.total})`}</small>
          </span>
        </span>
      </li>
    );
  }

  render() {
    // debugger
    let noData = <>No filters available</>;
    return (
      <>
        {this.props.isMobile !== true ? (
          <>
            <h4>Employer</h4>
            <hr />
          </>
        ) : (
          ""
        )}
        <div className="filter-fields-scroll">
          <ul className="chechbox-list longTextchbx">
            {!_.isEmpty(this.props.filterState.filterData) &&
            this.props.filterState.filterData.employer == undefined &&
            (this.props.filterState.filterData.employer === null ||
              this.props.filterState.filterData.employer.length === 0)
              ? noData
              : !_.isEmpty(this.props.filterState.filterData) &&
                this.props.filterState.filterData.employer.map((item) =>
                  this.chechboxes(item)
                )}
          </ul>
        </div>
        <div className="height-scroll"></div>
      </>
    );
  }
}

export default connect((state) => ({ filterState: state.advancedFilter }), {
  ...actionFilter,
})(Employer);
